<template lang="pug">
  v-card(v-bind="mergedAttrs" v-on="$listeners" :style="cardStyle" flat)
    slot
</template>

<script>
export default {
  name: "YzCard",
  props: {
    radius: {
      type: [String, Number],
      default: '10px'
    },
    color: {
      type: String,
      default: null
    },
    borderColor: {
      type: String,
      default: 'yz-neutral-300'
    },
    borderWidth: {
      type: [String, Number],
      default: 1
    },
    borderStyle: {
      type: String,
      default: 'solid',
      validator: value => ['solid', 'dashed', 'dotted'].includes(value)
    }
  },
  computed: {
    mergedAttrs() {
      // eslint-disable-next-line no-unused-vars
      const {tile, shaped, ...attrs} = this.$attrs
      return attrs
    },
    cardStyle() {
      const style = {}
      
      // Handle border radius
      style.borderRadius = typeof this.radius === 'number' ? `${this.radius}px` : this.radius
      
      // Handle background color
      if (this.color) {
        if (this.color.startsWith('#')) {
          style.backgroundColor = this.color
        } else if (this.color.startsWith('var(')) {
          style.backgroundColor = this.color
        } else if (this.color.startsWith('yz-')) {
          style.backgroundColor = `var(--${this.color})`
        } else {
          style.backgroundColor = `var(--yz-${this.color})`
        }
      }
      
      // Handle border properties only for outlined cards
      if (this.$attrs.outlined || this.$attrs.outlined === '') {
        // Handle border color
        if (this.borderColor) {
          if (this.borderColor.startsWith('#')) {
            style.borderColor = this.borderColor
          } else if (this.borderColor.startsWith('var(')) {
            style.borderColor = this.borderColor
          } else if (this.borderColor.startsWith('yz-')) {
            style.borderColor = `var(--${this.borderColor})`
          } else {
            style.borderColor = `var(--yz-${this.borderColor})`
          }
        }

        // Handle border width
        style.borderWidth = typeof this.borderWidth === 'number' ? `${this.borderWidth}px` : this.borderWidth

        // Handle border style
        style.borderStyle = this.borderStyle
      } else {
        // No borders for non-outlined cards
        style.borderStyle = 'none'
      }
      
      return style
    }
  }
}
</script>


<style scoped>

</style>